import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "checkmark-small-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.886 5.07a.75.75 0 0 1 1.285.765l-.057.095-3.5 5a.75.75 0 0 1-1.144.101l-.07-.081-1.5-2a.75.75 0 0 1 1.127-.984l.073.084.878 1.171L9.886 5.07z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
